const PRESS_DELAY_MS = 500
const MOVE_TOLERANCE_PX = 10
const bindings = new WeakMap()
const CONTROLS = 'button, input, select, textarea, [role="button"], [role="checkbox"], .v-simple-checkbox'

export default {
  inserted (el, binding) {
    // Listen on the cell so its padding also responds to the gesture.
    const surface = el.closest('td') || el
    const doc = surface.ownerDocument
    // Window capture runs before Vuetify's document-level outside-click handler.
    const clickTarget = doc.defaultView || surface
    const state = { value: binding.value, timer: null, press: null, suppressClick: false }

    function cancel () {
      clearTimeout(state.timer)
      state.timer = null
      state.press = null
      doc.removeEventListener('pointermove', move, true)
      doc.removeEventListener('pointerup', end, true)
      doc.removeEventListener('pointercancel', cancel, true)
      doc.removeEventListener('pointerdown', additionalPointer, true)
      doc.removeEventListener('scroll', cancel, true)
    }

    function move (event) {
      if (event.pointerId !== state.press?.pointerId) {
        return
      }
      if (Math.hypot(event.clientX - state.press.clientX, event.clientY - state.press.clientY) > MOVE_TOLERANCE_PX) {
        cancel()
      }
    }

    function end (event) {
      if (event.pointerId === state.press?.pointerId) {
        cancel()
      }
    }

    function additionalPointer (event) {
      if (event.pointerId !== state.press?.pointerId) {
        cancel()
      }
    }

    function start (event) {
      cancel()
      state.suppressClick = false
      if (!['touch', 'pen'].includes(event.pointerType) || event.isPrimary === false) {
        return
      }
      const control = event.target.closest(CONTROLS)
      if (control && surface.contains(control)) {
        return
      }

      state.press = {
        type: 'longpress',
        pointerId: event.pointerId,
        pointerType: event.pointerType,
        currentTarget: surface,
        target: event.target,
        clientX: event.clientX,
        clientY: event.clientY,
      }
      doc.addEventListener('pointermove', move, { capture: true, passive: true })
      doc.addEventListener('pointerup', end, true)
      doc.addEventListener('pointercancel', cancel, true)
      doc.addEventListener('pointerdown', additionalPointer, true)
      doc.addEventListener('scroll', cancel, { capture: true, passive: true })
      state.timer = setTimeout(() => {
        state.timer = null
        state.suppressClick = true
        state.value.open(state.value.item, state.press)
      }, PRESS_DELAY_MS)
    }

    function click (event) {
      if (!state.suppressClick) {
        return
      }
      if (surface.contains && !surface.contains(event.target)) {
        return
      }
      event.preventDefault()
      event.stopImmediatePropagation()
      state.suppressClick = false
    }

    function contextMenu (event) {
      if (state.press || state.suppressClick) {
        event.preventDefault()
      }
    }

    surface.addEventListener('pointerdown', start, { passive: true })
    clickTarget.addEventListener('click', click, true)
    surface.addEventListener('contextmenu', contextMenu)
    bindings.set(el, {
      state,
      cancel,
      destroy () {
        cancel()
        surface.removeEventListener('pointerdown', start)
        clickTarget.removeEventListener('click', click, true)
        surface.removeEventListener('contextmenu', contextMenu)
      },
    })
  },

  update (el, binding) {
    const active = bindings.get(el)
    if (!active) {
      return
    }
    if (active.state.value.item !== binding.value.item) {
      active.cancel()
      active.state.suppressClick = false
    }
    active.state.value = binding.value
  },

  unbind (el) {
    bindings.get(el)?.destroy()
    bindings.delete(el)
  },
}
